import {SpeakerInvitationCreateMessage} from "./SpeakerInvitationCreateMessage";

export enum SpeakerInvitationResponseStatus {
    Ok = 1,
    Sent = 2,
    Expired = 3,
    Cancelled = 4,
    NotFound = 5
}

export default interface SpeakerInvitationResponse {
    status: SpeakerInvitationResponseStatus;
    body: SpeakerInvitationCreateMessage;
}